(function () {
  function formatRating(value) {
    const rating = Number(value);
    if (!Number.isFinite(rating) || rating <= 0) return '';
    return rating.toFixed(1);
  }

  function formatReviewCount(value) {
    const count = Number(value);
    if (!Number.isFinite(count) || count <= 0) return '';
    return `${count} ${count === 1 ? 'reseña' : 'reseñas'}`;
  }

  function normalizeBadgeText(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.jdgm-widget.jdgm-preview-badge .jdgm-prev-badge').forEach((badge) => {
      const textEl = badge.querySelector('.jdgm-prev-badge__text');
      if (!textEl) return;

      const rating = formatRating(badge.dataset.averageRating);
      const reviews = formatReviewCount(badge.dataset.numberOfReviews);
      if (!rating || !reviews) return;

      const text = `${rating}/5 (${reviews})`;
      if (textEl.textContent.trim() !== text) {
        textEl.textContent = text;
      }

      const starsEl = badge.querySelector('.jdgm-prev-badge__stars');
      if (starsEl) {
        starsEl.setAttribute('aria-label', `Ver ${reviews}`);
      }
    });
  }

  function scheduleNormalize(root) {
    window.requestAnimationFrame(() => normalizeBadgeText(root));
  }

  scheduleNormalize(document);
  document.addEventListener('DOMContentLoaded', () => scheduleNormalize(document));
  document.addEventListener('shopify:section:load', (event) => scheduleNormalize(event.target));

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target && mutation.target.closest && mutation.target.closest('.jdgm-preview-badge')) {
        scheduleNormalize(mutation.target.closest('.jdgm-preview-badge'));
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.querySelector('.jdgm-preview-badge')) {
          scheduleNormalize(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
